import { Paginator } from './index'

export type TokenChain = {
  address: `0x${string}`
  chainId: number
  decimals: number
  id: string
  isActive: true
  tokenId: string
}

export type Token = {
  arbitraryData: string
  description: string
  id: string
  isPopular: boolean
  isSpam: boolean
  logo: string
  name: string
  ticker: string
  tokenChains: Array<TokenChain>
  tokenType: 'Custom_Token' | 'LP_Token' | 'NFT_Token' | 'Token'
}

export type EditTokenPayload = Omit<Token, 'id' | 'tokenChains'> & {
  tokenChains: Omit<TokenChain, 'id' | 'tokenId'>[]
}

export type TokenResponse = Paginator & {
  data: Array<Token>
}

export type TokenWithBalance = Token & {
  balance: string
  balanceInUsd?: string
}

export enum AvailableValueToken {
  usdt = 'usdt',
  usdc = 'usdc',
}
